<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import AlternativesQueries from '@Alternatives/Alternatives/Domain/queries-vue-component';
    import { EditAlternativePageReadModel } from '@Alternatives/Alternatives/Domain/readmodels';
    import AlternativeEditor from '@Alternatives/Alternatives/Components/AlternativeEditor.vue';
    import { AlternativeAttributeValueDTO } from '@Alternatives/Model';
    import AlternativesCommands from '@Alternatives/Alternatives/Domain/commands-vue-component';
    import { UpdateAlternativeCommandV1 } from '@Alternatives/Alternatives/Domain/commands-core';
    import { ICommandBase } from '@Alternatives/cqrs';
    import { ICommandStatus } from '@cqrs/cqrs';

    @Component({
        components: { AlternativeEditor }
    })
    export default class EditAlternativePage extends mixins(AlternativesQueries, AlternativesCommands)
    {
        get alternativeId(): string { return this.$route.params.alternativeId; }
        get formId(): number | null { return this.$route.params.formId != null ? Number.parseInt(this.$route.params.formId) : null; }

        rm: EditAlternativePageReadModel = null;

        errors: ValidationError[] = [];


        save(name: string, description: string, statusId: number, attributeValues: AlternativeAttributeValueDTO[])
        {
            this.errors = [];
            this.invokeUpdateAlternativeCommandV1(this.rm.UserId, this.rm.WorkspaceId, this.rm.ProjectId, this.rm.AlternativesListId, this.formId, this.alternativeId, name, description, statusId, attributeValues);
        }

        
        mounted()
        {
            this.runEditAlternativePageQueryV1(this.alternativeId, this.formId);
        }

        onSetModel(model: any, modelName: string) 
        {
            if (modelName == "EditAlternativePageReadModel")
            {
                this.rm = model as EditAlternativePageReadModel;
                document.title = `Edit ${this.rm.AlternativeLabel} | TransparentChoice`;
            }
        }

        onCommandSucceed(cmd: ICommandBase, correlationId: string)
        {
            if (UpdateAlternativeCommandV1.matchType(cmd))
            {
                window.location.reload();
            }
        }

        onCommandFailed(status: ICommandStatus)
        {
            if (UpdateAlternativeCommandV1.matchType(status.Command))
            {
                this.errors = status.ValidationErrors;
            }
        }
    }
</script>

<template>
    <div v-if="rm">
        <nav class="navbar navbar-expand-sm navbar-light bg-light fixed-top">
            <div class="container justify-content-end">
                <button type="submit" class="btn btn-lg btn-success" form="editAlternativePageAlternativeForm">Save Changes</button>
            </div>
        </nav>

        <div class="container">
            <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Edit <span style="text-transform: lowercase;">{{rm.AlternativeLabel}}</span></h1>

            <hr style="border-color: #bbb; margin: 20px 0 30px;" />

            <div class="alert alert-warning" role="alert">
                Please remember to press Save Changes before refreshing this page and when the questionnaire is complete!
            </div>

            <AlternativeEditor :propRm="rm.AlternativeEditor" :propErrors="errors" propFormId="editAlternativePageAlternativeForm"
                               @form-submit="save" />
        </div>

    </div>
</template>

